import { apiClient } from "./config";

/**
 * Get templates plans content preset editor
 * @param {templatePlan, contentPreset, configuration_id} params
 * @param successCallback
 * @param errorCallback
 * @returns {Promise<*>}
 */
export const getTemplatesPlansContentPresetEditor = async (
	params,
	successCallback = false,
	errorCallback = false
) => {
	const { templatePlan, contentPreset, ...body } = params;

	try {
		const response = await apiClient.get(
			`/admin/templates/plans/${templatePlan}/content-presets/${contentPreset}/editor`,
			{ params: body }
		);
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};

/**
 * Search templates plans content preset editor
 * @param {templatePlan, contentPreset, configuration_id, q} params
 * @param successCallback
 * @param errorCallback
 * @returns {Promise<*>}
 */
export const searchTemplatesPlansContentPresetEditor = async (
	{ params, options },
	successCallback = false,
	errorCallback = false
) => {
	const { templatePlan, contentPreset, ...body } = params;

	try {
		const response = await apiClient.get(
			`/admin/templates/plans/${templatePlan}/content-presets/${contentPreset}/editor/search`,
			{ params: body, ...options }
		);
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};

/**
 * Get templates plans content preset editor content
 * @param {templatePlan, contentPreset, templateChapterContent, configuration_id} params
 * @param successCallback
 * @param errorCallback
 * @returns {Promise<*>}
 */
export const getTemplatesPlansContentPresetEditorContent = async (
	params,
	successCallback = false,
	errorCallback = false
) => {
	const { templatePlan, contentPreset, templateChapterContent, ...body } = params;

	try {
		const response = await apiClient.get(
			`/admin/templates/plans/${templatePlan}/content-presets/${contentPreset}/editor/contents/${templateChapterContent}`,
			{ params: body }
		);
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};

/**
 * Edit templates plans content preset editor content
 * @param {editorjs, status, admin_note, reset_override, configuration_id, lock_version, templatePlan, contentPreset, templateChapterContent} body
 * @param {function} successCallback
 * @param {function} errorCallback
 * @returns
 */
export const editTemplatesPlansContentPresetEditorContent = async (
	body,
	successCallback = false,
	errorCallback = false
) => {
	const { templatePlan, contentPreset, templateChapterContent, ...data } = body;

	try {
		const response = await apiClient.patch(
			`/admin/templates/plans/${templatePlan}/content-presets/${contentPreset}/editor/contents/${templateChapterContent}`,
			data
		);
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};

/**
 * Edit templates plans content preset editor requirement
 * @param {requirement_status_id, start_date, end_date, budget, note, percentage, configuration_id, lock_version, templatePlan, contentPreset, templateRequirement} body
 * @param {function} successCallback
 * @param {function} errorCallback
 * @returns
 */
export const editTemplatesPlansContentPresetEditorRequirement = async (
	body,
	successCallback = false,
	errorCallback = false
) => {
	const { templatePlan, contentPreset, templateRequirement, ...data } = body;

	try {
		const response = await apiClient.patch(
			`/admin/templates/plans/${templatePlan}/content-presets/${contentPreset}/editor/requirements/${templateRequirement}`,
			data
		);
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};
